/**
 * Console Greeting - A nice message for curious developers
 *
 * If you're reading this code, you're exactly the kind of person we love to work with!
 */

export function initialize(): void {
  // Only show in browser environment
  if (typeof window === 'undefined' || typeof console === 'undefined') {
    return;
  }

  // Wait a bit for the app to load, then show the message
  setTimeout(() => {
    // ASCII art inspired by the angular Madow Tech logo
    const asciiLogo = `
███╗   ███╗ █████╗ ██████╗  ██████╗ ██╗    ██╗
████╗ ████║██╔══██╗██╔══██╗██╔═══██╗██║    ██║
██╔████╔██║███████║██║  ██║██║   ██║██║ █╗ ██║
██║╚██╔╝██║██╔══██║██║  ██║██║   ██║██║███╗██║
██║ ╚═╝ ██║██║  ██║██████╔╝╚██████╔╝╚███╔███╔╝
╚═╝     ╚═╝╚═╝  ╚═╝╚═════╝  ╚═════╝  ╚══╝╚══╝
        ████████╗███████╗ ██████╗██╗  ██╗
        ╚══██╔══╝██╔════╝██╔════╝██║  ██║
           ██║   █████╗  ██║     ███████║
           ██║   ██╔══╝  ██║     ██╔══██║
           ██║   ███████╗╚██████╗██║  ██║
           ╚═╝   ╚══════╝ ╚═════╝╚═╝  ╚═╝
`;

    const styles = {
      logo: 'color: #ff6b35; font-family: monospace; font-size: 10px; line-height: 1.2;',
      subtitle: 'color: #f7c59f; font-size: 16px; font-weight: bold;',
      body: 'color: #efefef; font-size: 14px;',
      highlight: 'color: #ff6b35; font-size: 14px; font-weight: bold;',
      link: 'color: #4dabf7; font-size: 14px; text-decoration: underline;',
    };

    console.log('%c' + asciiLogo, styles.logo);
    console.log('%c👋 Hey there, curious developer!', styles.subtitle);
    console.log('%c', 'font-size: 4px;'); // spacer
    console.log('%cLike what you see? We built this with:', styles.body);
    console.log('%c  ⚡ Ember.js + TypeScript', styles.body);
    console.log('%c  🎨 Tailwind CSS', styles.body);
    console.log('%c  🌌 Custom WebGL Mars canvas', styles.body);
    console.log('%c  ✨ A lot of passion', styles.body);
    console.log('%c', 'font-size: 4px;'); // spacer
    console.log('%cWe\'re a young team of experienced developers who build', styles.body);
    console.log('%cweb platforms, mobile apps, and digital products that work.', styles.body);
    console.log('%c', 'font-size: 4px;'); // spacer
    console.log('%c🔥 Want to join us or work with us?', styles.highlight);
    console.log('%c📧 hello@madow.tech', styles.link);
    console.log('%c🌐 https://madow.tech', styles.link);
    console.log('%c', 'font-size: 4px;'); // spacer
    console.log('%c"Turning complex requirements into elegant, maintainable code."', 'color: #888; font-style: italic; font-size: 12px;');
    console.log('%c- The Madow Tech Team 🛠️', 'color: #888; font-size: 12px;');
  }, 1000);
}

export default {
  name: 'console-greeting',
  initialize,
};
